import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getVendorFaqQuestions = (siteTitle, vehicleType) => [
  {
    question: `Does it cost to sign up to ${siteTitle}?`,
    answer: `No — creating an account on ${siteTitle} is completely free for food ${vehicleType} owners. You can build your profile, get discovered by customers, and access event opportunities at no cost. Some premium opportunities, such as reserved vending locations or structured catering programs, may include fees, but pricing is always clearly outlined upfront. There are no hidden costs and no long-term commitments.`
  },
  {
    question: `What kind of events can food ${vehicleType}s book through ${siteTitle}?`,
    answer: `${siteTitle} connects food ${vehicleType} owners with events of all sizes, ranging from small private gatherings to large-scale festivals and corporate events serving 50 to 50,000+ guests. Vendors regularly book weddings, birthday parties, neighborhood events, and recurring corporate catering, including office lunches and employee appreciation events for some of the world's biggest brands throughout the Seattle area.`
  },
  {
    question: `How many food ${vehicleType}s and vendors do you work with?`,
    answer: `Since 2011, ${siteTitle} has partnered with over 1,000 food ${vehicleType}s and mobile food businesses across the region. We focus on working with reliable, professional vendors and building long-term relationships that support consistent bookings, repeat clients, and sustainable growth.`
  },
  {
    question: `What documentation is required to become a ${siteTitle} vendor?`,
    answer: "To ensure all vendors meet local and state requirements, we may request standard documentation such as health permits, business licenses, and insurance. Any required documents will be clearly listed during the application process, so you'll know exactly what's needed to get approved and start booking events."
  }
];

function VendorFaq() {
  const { site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getVendorFaqQuestions(site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default VendorFaq;
